import { useState } from "react";
import { useEffect } from "react";
import Navbar from "../components/Navbar";
import jwt_decode from "jwt-decode";
import { isUserValid, loginOAuth } from "../lib/pocketbase";
const AuthModal = () => {
    const [user, setUser] = useState({});

    function handleCallbackResponse(response) {
        //console.log("Encoded JWT ID Token: " + response.credential);
        var userObject = jwt_decode(response.credential);
        console.log(userObject);
        setUser(userObject);
        document.getElementById("customSignInButton").hidden = true;
    }

    function handleSignout(event) {
        setUser({});
        document.getElementById("customSignOutButton").hidden = true;
    }

    useEffect(() => {
        /* global google */
        google.accounts.id.initialize({
            client_id: "308462231943-0hlh6avg60olgs7lmoe93pqaiqe2hme0.apps.googleusercontent.com",
            callback: handleCallbackResponse
        });
    }, []);

    return (
        <div>
            <input type="checkbox" id="my_modal_7" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box bg-base-300">
                    <h3 className="font-bold text-3xl">
                        Sign in with <span className="underline">Google</span>
                    </h3>
                    <div className="mt-5 text-lg text-gray-400">
                        <p className="mb-5">Access all of the features by signing in and getting started with RideHub.</p>
                        <p>You must sign in with your Cornell email to sign into RideHub!</p>
                    </div>
                    <div className="flex justify-center modal-action">
                        <label
                        htmlFor="my_modal_7"
                    id="customSignInButton"
                    className="btn btn-secondary normal-case text-xl w-full"
                    onClick={() => google.accounts.id.prompt()}
                >
                    Sign In with Google
                </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuthModal;
